import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable()

export class Database {

  constructor() {}

  getData(ref) {
    const q = firebase.database().ref(ref);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  getDataEqual(ref, child, equal) {
    const q = firebase.database().ref(ref).orderByChild(child).equalTo(equal);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

/**
   * pushData sin key
   *
   * @description push data in database firebase
   */
  pushDatakey(ref, dataObject, key) {
    let updateData = {};

    dataObject.id = key;

    updateData[ref + "/" + key] = dataObject;

    return new Promise((resolve, reject) => {
      firebase.database().ref().update(updateData)
      .then((result) => {
        // TODO: view return data
        // TODO: Push log data
        resolve(result)
      })
      .catch((error) => {
        reject(error)
      });
    });
  }


  /**
   * pushData
   *
   * @description push data in database firebase
   */
  pushData(ref, dataObject) {
    let updateData = {};
    let newKey = firebase.database().ref().child(ref).push().key;

    dataObject.id = newKey;

    updateData[ref + "/" + newKey] = dataObject;

    return new Promise((resolve, reject) => {
      firebase.database().ref().update(updateData)
      .then((result) => {
        console.log(result)
        // TODO: view return data
        // TODO: Push log data
        resolve(dataObject.id);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  updateData(ref, dataObject) {
    // Update data ref
    return new Promise((resolve, reject) => {
      firebase.database().ref(ref).set(dataObject)
      .then(() => {
        // TODO: Push log data
        resolve(true);
      })
      .catch((error) => {
        reject(error)
      });
    });
  }

  deleteData(ref){
    return new Promise((resolve,reject)=>{
      if (ref) {
        firebase.database().ref(ref).remove()
        .then(()=>{
          resolve(true);
        })
        .catch((error)=>{
          reject(error)
        });
      } else {
        reject(false);
      }
    });
  }

  generateRef(ref) {
    return new Promise((resolve, reject) => {
      resolve(firebase.database().ref().child(ref));
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/database.ts